<template>
    <div>
        <div class="row" v-show="chunks.length && !loadingState">
            <div class="col px-0">
                <div class="jumbotron jumbotron-fluid">
                    <div class="container text-center">
                        <div class="row">
                            <div class="offset-1 col-10">
                                <div class="row">
                                    <div class="col-4">
                                        <img id="promotional-image" width="100%">
                                    </div>
                                    <div class="col-8">
                                        <span id="anime-name" class="display-4"></span>
                                        <p id="anime-genres" class="lead"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="offset-1 col-10 mt-3">
                                <p id="anime-synopsis" class="text-justify"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row my-3">
            <div id="main-two" class="col">
                <div class="row" v-for="(chunk, index) in chunks" :key="index">
                    <div class="col-md-10 offset-1">
                        <div class="list-group">
                            <router-link :to="'/episode/'+episode.id"
                                         class="list-group-item list-group-item-action flex-column align-items-start"
                                         v-for="(episode, index) in chunk" :key="index">
                                <div class="d-flex w-100 justify-content-between">
                                    <h5 class="mb-1">Episodio #{{ episode.name }}</h5>
                                    <small>Lanzamiento: {{ episode.release_date }}</small>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>

                <div class="row my-3" v-show="!chunks.length && !loadingState">
                    <div class="offset-2 col-8">
                        <div class="row">
                            <div class="col-12"><h1 class="text-center">No se encontraron resultados</h1></div>
                            <div class="offset-4 col-4 mt-3">
                                <img src="../assets/glass.png" width="100%">
                            </div>
                        </div>
                    </div>
                </div>

                <div style="margin-top: 200px" v-show="loadingState">
                    <ring-loader></ring-loader>
                    <h1>Cargando...</h1>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {http} from './../misc/http';
    import {RingLoader} from 'vue-spinners-css';
    import moment from "moment";

    export default {
        name: "anime",
        components: {
            RingLoader,
        },
        data() {
            return {
                APP_URL: 'http://legion-dashboard.test',
                WEBAPP_URL: 'https://legion-anime.test',
                CONST_CHUNK_SIZE: 10,
                chunks: [],
                anime_id: null,
                anime: {
                    name: 'Cargando...',
                    genres: '',
                    synopsis: '',
                },
                episodes: [],
                loadingState: true,
                thumbsPrefix: '',
            }
        },
        created() {
            Array.prototype.chunk = function (n) {
                if (!this.length) {
                    return [];
                }
                return [this.slice(0, n)].concat(this.slice(n).chunk(n));
            };
        },
        mounted() {
            this.setThumbPrefix();
            this.anime_id = this.$route.params.anime_id;
            setTimeout(() => {
                this.loadEpisodes();
            }, 100);
        },
        methods: {
            setThumbPrefix() {
                this.thumbsPrefix = this.shuffle(this.getSpaces())[0];
            },
            getSpaces() {
                let spaces = process.env.VUE_APP_SPACES;
                spaces = spaces.split(',').map(space => {
                    return `https://la-space-${space}.sfo2.cdn.digitaloceanspaces.com/`;
                });
                //spaces.push('https://la-space.sfo2.cdn.digitaloceanspaces.com/');
                return spaces;
            },
            setGrid(episodes) {
                this.chunks = episodes.chunk(this.CONST_CHUNK_SIZE);
            },
            reduceCounter(total) {
                if (total > 1000) {
                    return (total / 1000).toFixed(1) + "K";
                }

                return total;
            },
            async loadEpisodes() {
                this.toggleLoading(true);
                let anime = localStorage.getItem(`anime_${this.anime_id}`);
                let episodes = localStorage.getItem(`anime_${this.anime_id}_episodes`);
                let anime_expires_at = localStorage.getItem(`anime_${this.anime_id}_expires_at`);

                if (anime === null || (anime && moment().isAfter(anime_expires_at))) {
                    try {
                        const url = `episodes/${this.anime_id}`;
                        const response = await http.get(url);
                        if (response.data.success) {

                            localStorage.setItem(`anime_${this.anime_id}`, JSON.stringify(response.data.response.anime));
                            localStorage.setItem(`anime_${this.anime_id}_episodes`, JSON.stringify(response.data.response.episodes));
                            localStorage.setItem(`anime_${this.anime_id}_expires_at`, moment().add(6, 'hours'));

                            anime = response.data.response.anime;
                            episodes = response.data.response.episodes;

                            /*this.anime = response.data.response.anime;
                            this.setGrid(response.data.response.episodes);
                            this.setPromotionalImage();
                            document.querySelector('#anime-name').innerHTML = this.anime.name;
                            document.querySelector('#anime-genres').innerHTML = this.anime.genres;
                            document.querySelector('#anime-synopsis').innerHTML = this.anime.synopsis;*/
                        } else {
                            this.chunks = [];
                        }
                        // eslint-disable-next-line no-empty
                    } catch (error) {
                        this.chunks = [];
                    }
                } else {
                    anime = JSON.parse(anime);
                    episodes = JSON.parse(episodes);
                }

                this.toggleLoading(false);
                this.anime = anime;
                this.setGrid(episodes);
                this.setPromotionalImage();
                document.querySelector('#anime-name').innerHTML = this.anime.name;
                document.querySelector('#anime-genres').innerHTML = this.anime.genres;
                document.querySelector('#anime-synopsis').innerHTML = this.anime.synopsis;
            },
            toggleLoading(state = null) {
                this.loadingState = state || !this.loadingState;
            },
            setPromotionalImage() {
                let image = document.querySelector('#promotional-image');
                image.src = `${this.shuffle(this.getSpaces())[0]}${this.anime.img_large_url}`;
            },
            imgUrlAlt(event) {
                event.target.src = "../assets/default.png";
            },
            shuffle(array) {
                return array.sort(() => Math.random() - 0.5);
            },
        }
    }
</script>

<style scoped>

</style>
